import { Outlet } from "react-router-dom";
import { Spinner } from "components/ui/spinner";
import Sidebar from "./components/Sidebar";
import Header from "./components/Header";
import Actions from "./components/Actions";
import { useProfileQuery } from "./api/useProfileQuery";

function Profile() {
    const { isLoading } = useProfileQuery();

    return (
        <div className="tw-flex tw-gap-1 tw-h-full tw-w-full tw-p-5 tw-h-[calc(100%-60px)] tw-bg-white tw-rounded-lg">
            {isLoading ? (
                <div className="tw-flex tw-items-center tw-justify-center tw-w-full">
                    <Spinner className="tw-size-8 tw-text-primary" />
                </div>
            ) : (
                <>
                    <Sidebar />
                    <div className="tw-flex tw-flex-col tw-h-full tw-min-h-0 tw-flex-1 tw-min-w-0">
                        <Header />
                        <div className="tw-flex tw-flex-col lg:tw-flex-row tw-gap-1 tw-flex-1 tw-min-h-0 tw-overflow-hidden">
                            <div className="tw-min-w-0 tw-flex-1 tw-min-h-0 tw-overflow-y-auto tw-order-2 lg:tw-order-1">
                                <Outlet />
                            </div>
                            <Actions />
                        </div>
                    </div>
                </>
            )}
        </div>
    );
}

export default Profile;
